<template>
	<v-navigation-drawer
		v-model="show"
		app
		v-if="login"
	>
		<v-list
			dense
			v-for="item in menu"
			:key="item.label"
		>
			<v-list-item
				v-if='typeof item === "object"'
				@click="onClick(item.route)"
				:key="item.label"
			>
				<v-list-item-action>
					<v-icon>{{item.icon}}</v-icon>
				</v-list-item-action>
				<v-list-item-content>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-title v-bind="attrs" v-on="on">{{item.label}}</v-list-item-title>
            </template>
            <span>{{ item.label }}</span>
          </v-tooltip>
				</v-list-item-content>
			</v-list-item>
			<v-divider v-else-if="item === 'divider'"></v-divider>
			<v-subheader v-else>{{item}}</v-subheader>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
  export default {
    name: "NavigationPanel",
    props: {
      drawer: Boolean,
      login: String,
      menu: Array,
      changePage: Function,
      changeShowNavigation: Function,
    },
    computed: {
      show: {
        get: function () {
          return this.drawer;
        },
        set: function (val) {
          this.changeShowNavigation(val);
        }
      },
    },
    methods: {
      onClick: function (val) {
        this.changeShowNavigation(false);
        this.changePage(val);
      },
    },
  }
</script>

<style scoped>

</style>
